import React from 'react';
import { BrowserRouter, Route, Switch/* , Link, NavLink */ } from 'react-router-dom';
//import LandingPage from '../pages/LandingPage/LandingPage';
import HomePage from '../pages/HomePage/HomePage';
import ResultsPageTickets from '../pages/ResultsPage/ResultsPage';
import ResultsPagePasses from '../pages/ResultsPagePasses/ResultsPagePasses';
import CheckoutPage from '../pages/ResultsPage/CheckoutPage';
import ThankYouPage from '../pages/ThankYouPage/ThankYouPage';
import LoginPage from '../pages/LoginPage/LoginPage';
//import NotFoundPage from '../pages/NotFoundPage/NotFoundPage';
//import LoginPage from '../pages/LoginPage/LoginPage';

import PublicRoute from './PublicRouter';

//import PrivateRoute from './PrivateRouter';

export default function Routing(props) {

  return (
    
    <BrowserRouter>
      <Switch>
        <Route path="/:token/trenes/results/tickets/:origin/:destination/:departure/:time/:ages" component={ResultsPageTickets} />
        <Route path="/:token/trenes/results/passes/:origin/:departure/:time/:ages" component={ResultsPagePasses} />
        <PublicRoute path="/:token/trenes/" component={HomePage} exact={true} />
        <Route path="/:token/trenes/checkout/" component={CheckoutPage}  />
        <Route path="/:token/trenes/booking/" component={ThankYouPage}  />
        <Route path="/:token/trenes/login/" component={LoginPage}  />
        {/* <Route component={NotFoundPage} /> */}
      </Switch>
    </BrowserRouter>
  )

  /* return (
    <BrowserRouter>
        <Switch>
            <Route path={"/:module/prebooking/:hash"} component={Layout} exact />
            <Route path={config.defaultErrorRoute} component={LayoutError} exact />
            {
                config.routesError.map((routeError, i) =>
                    <Route path={routeError.path} exact key={i} >
                        <ErrorViewHandler pathConfig={routeError.path} />}
                    </Route>
                )
            }
        </Switch>
    </BrowserRouter>
  ) */
}
